import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useCompanyStore = create()(persist((set) => ({
    company: null,
    isCompanyReady: false,
    setCompany: (data) => set({ company: data, isCompanyReady: true }),
    clearCompany: () => set({ company: null, isCompanyReady: false }),
    setDocumentGenerationStatus: (status) => set((state) => {
        if (!state.company)
            return state;
        return {
            company: Object.assign(Object.assign({}, state.company), { documentGenerationStatus: status }),
        };
    }),
    setFormProgressStatus: (status) => set((state) => {
        if (!state.company)
            return state;
        return {
            company: Object.assign(Object.assign({}, state.company), { formStatus: status }),
        };
    }),
}), {
    name: 'company-storage',
}));
